module.exports = __webpack_public_path__ + "static/media/client8.668bc9f6.svg";